// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dZ-s","col":"styles_col__lCnOj"};